/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Curly_Direct_Earthworm_BaskInputs */

const en_curly_direct_earthworm_bask = /** @type {(inputs: Curly_Direct_Earthworm_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_curly_direct_earthworm_bask = /** @type {(inputs: Curly_Direct_Earthworm_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Curly_Direct_Earthworm_BaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const curly_direct_earthworm_bask = /** @type {((inputs?: Curly_Direct_Earthworm_BaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Curly_Direct_Earthworm_BaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_curly_direct_earthworm_bask(inputs)
	return de_curly_direct_earthworm_bask(inputs)
});